export enum Timers {
  AWAIT200MS = 200,
  AWAIT1000MS = 1000,
  AWAIT4000MS = 4000,
  AWAIT5000MS = 5000,
  AWAIT6000MS = 6000,
}
